function About() {
  return <>About</>;
}

export default About;